<section id="cymipage" class="gennius--intro sec-cymi">
    <div class="tabs" [ngClass]="{'fixed': fixed}">
        <div class="cryptmi" pageScroll href="#cryptmi-zero" [routerLink]="['/cryptmi']" [routerLinkActive]="['active']">
            <img src="./assets/img/cryptmi/logo-cryptmi.svg" alt="">
        </div>
        <div class="cymi active" pageScroll href="#cymi" [routerLink]="['/cymi']" [routerLinkActive]="['active']">
            <img src="./assets/img/cryptmi/logo-cymi-w.png" alt="">
        </div>
    </div>
    <div class="container">
        <div class="gennius__bloque">
            <h1 class="text-gradient">A token like no other</h1>
            <p><strong>CYMi is a base layer utility token</strong> running on the Ethereum blockchain that offers interoperability and instant swaps between loyalty programs, fiat currencies, and the crypto market, allowing users to pay for everyday essentials at over 100 million merchants around the world, as well as for NFTs and purchases in the Web3.</p>
        </div>
        <div class="gennius__bloque gennius__bloque--video">
            <video loop="loop" playsinline="" controls poster="./assets/img/gennius/video-cymi.jpg" preload="none">
                <source
                    src="https://player.vimeo.com/progressive_redirect/playback/797862293/rendition/720p/file.mp4?loc=external&signature=deae96d24ae174781ab6664a814b08ee866418b18edc7181afeafdb855e0c36b"
                    type="video/mp4">
            </video>
        </div>
    </div>
</section>




<app-footer></app-footer>
    <!-- <app-connect></app-connect>
    <iframe *ngIf="!itsMobile" src='https://my.spline.design/yelociqJ-iWJjcpiRauQq0IV/' frameborder='0' width='100%' height='100%'></iframe>
    <iframe *ngIf="itsMobile" src='https://my.spline.design/cymimobile-6670662614946b6a0e6a6d9aed439c75/' frameborder='0' width='100%' height='100%'></iframe> -->
    <!-- <div class="scroll-helper">
        <svg width="18" height="27" viewBox="0 0 18 27" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-67b66c84=""><rect x="1" y="5" width="16" height="21" rx="5" stroke="black" stroke-width="2" data-v-67b66c84=""></rect> <line x1="9" y1="9" x2="9" y2="14" stroke="black" stroke-width="2" data-v-67b66c84=""></line></svg>
        <span>Scroll</span>
    </div> -->
<!-- <section class="main-section s-cymi">
    <section #cymi>
        <div class="tabs" [ngClass]="{'fixed': fixed}">
            <div class="cryptmi" pageScroll href="#cryptmi-zero" [routerLink]="['/cryptmi']" [routerLinkActive]="['active']">
                <img src="./assets/img/cryptmi/logo-cryptmi.svg" alt="">
            </div>
            <div class="cymi active" pageScroll href="#cymi" [routerLink]="['/cymi']" [routerLinkActive]="['active']">
                <img src="./assets/img/cryptmi/logo-cymi.png" alt="">
            </div>
        </div>
    </section>
</section> -->
